/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-03-09 09:42:55
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-03-09 16:57:50
 * @FilePath: \crm-product\src\views\dms\views\sharing_agreement\cash_distribution\form\details\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import detailsInfo from './details.vue';

formCreate.component('detailsInfo', detailsInfo);
export default {
  extends: Form,
  data() {
    return {
      formFunctionCode: 'detailsForm',
      formParentCode: 'CRM20260309000000002',
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  created() {

  },

  methods: {
    formComplete() {
      this.getDetails();
      console.log(this.formConfig);
    },
    setRule(item) {
      const v = item;
      if (v.field === 'detailsInfo') {
        v.props = {
          mainId: this.formConfig.row.id,
        };
      }
      return v;
    },
    async getDetails() {
      await request.post('/cps/cpsagreerewardprocess/query', {
        id: this.formConfig.row.id,
      }).then((res) => {
        if (res.success) {
          this.setValue({
            ...res.result,
          });
        }
      });
    },
  },
};
